import { render, staticRenderFns } from "./AssociarLotesDlg.vue?vue&type=template&id=065c2d1c&scoped=true"
import script from "./AssociarLotesDlg.vue?vue&type=script&lang=js"
export * from "./AssociarLotesDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c2d1c",
  null
  
)

export default component.exports